import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "src/@/components/ui/dropdown-menu"
import Iconify from "src/components/Iconify"

export function SupervisaoExport({
    onExportListChats,
    onExportListChatsPrimeiroContato,
    className = '',
}) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button type="button" className={className}>
                    Exportar
                    <Iconify icon="iconamoon:arrow-down-2-bold" className="w-4 h-4" />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                <DropdownMenuItem onClick={onExportListChats}>
                    Exportar chats (.xlsx)
                </DropdownMenuItem>
                <DropdownMenuItem onClick={onExportListChatsPrimeiroContato}>
                    Exportar chats primeiro contato (.xlsx)
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    )
}
